import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setUser } from '../../store/slices/authSlice';
import {
  Container,
  Paper,
  TextInput,
  PasswordInput,
  Button,
  Title,
  Loader,
  Center,
  useMantineTheme,
} from '@mantine/core';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';
import ApiLinks from '../../Navlinks/ApiLinks';

function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false); 
  const theme = useMantineTheme();

  // 👇 Set body background color only on this page
  useEffect(() => {
    document.body.style.backgroundColor = '#2fb0c4'; // purple

    // optional: reset when component unmounts
    return () => {
      document.body.style.backgroundColor = ''; // revert to default
    };
  }, []);


  const handleLogin = async (e) => {
    e.preventDefault();


    if (!email || !password) {
      toast.error('Email and Password are required!');
      return;
    }

    setLoading(true); // ✅ Show loader

    try {

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/${ApiLinks.login}/${encodeURIComponent(email)}/${password}`
      );

      if (response.data.status === true) {
        const userData = response.data.data;
        dispatch(setUser(userData));
        navigate('/dashboard');
      }
      else {

         // 🧁 SweetAlert for login failure
      Swal.fire({
        icon: 'error',
        title: 'Login Failed',
        text: 'Invalid email or password',
      });

      // 🔥 Toast (optional)
      toast.error('Login failed. Check your credentials.');

      }


    } catch (error) {
      console.error('Login failed:', error);
      // show error if needed
    } finally {
      setLoading(false); // ✅ Hide loader
    }
  };

  return (
    <Center style={{ height: '100vh' }}>
    <Container  className='login-card'>
      <Title align="center" style={{ color: theme.colors.cyan[9] }} >Login</Title>
      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        {loading ? (
          <Center my="xl">
            <Loader size="lg" />
          </Center>
        ) : (
          <form onSubmit={handleLogin}>
            <TextInput
              label="Email"
              placeholder="your@email.com"
              required
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
            />
            <PasswordInput
              label="Password"
              placeholder="Your password"
              required
              mt="md"
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
            />
            <Button fullWidth mt="xl" type="submit">
              Sign in
            </Button>
          </form>
        )}
      </Paper>
    </Container>
    </Center>
  );
}

export default LoginPage;
